import React from "react";
import {
  FaCheckCircle,
  FaQuestionCircle,
  FaEdit,
  FaEyeSlash,
  FaRegCalendarAlt,
} from "react-icons/fa";
import { getPointColor } from "../../utils/pointColor";
import { Button, Modal } from "../../ui";

// مصنع الأسئلة — question detail. View-only for non-owners; owner gets "تعديل".
const QuestionDetail = ({ question, isOwner, onEdit, onClose }) => {
  if (!question) return null;
  const color = getPointColor(question.points);
  const date = question.createdAt
    ? new Date(question.createdAt).toLocaleDateString("ar", { numberingSystem: "latn" })
    : null;

  return (
    <Modal
      open
      onClose={onClose}
      size="lg"
      title={
        <span
          className="inline-flex items-center rounded-full px-4 py-1 text-base font-bold text-white"
          style={{ backgroundColor: color }}
        >
          {question.points} نقطة
        </span>
      }
    >
      <div className="rounded-2xl border border-white/10 bg-white/[0.05] p-4 mb-3">
        <div className="flex items-center gap-2 text-sm font-semibold text-white/70 mb-2">
          <FaQuestionCircle className="text-primary" /> السؤال
        </div>
        <p className="text-white leading-relaxed whitespace-pre-line">{question.question}</p>
        {question.questionImage && (
          <img
            src={question.questionImage}
            alt=""
            className="w-full rounded-xl mt-3 max-h-64 object-contain bg-white"
          />
        )}
      </div>

      <div className="rounded-2xl border border-success/40 bg-success/[0.08] p-4 mb-3">
        <div className="flex items-center gap-2 text-sm font-semibold text-white/70 mb-2">
          <FaCheckCircle className="text-success" /> الإجابة الصحيحة
        </div>

        <>
          <p className="text-white leading-relaxed whitespace-pre-line">{question.answer}</p>
          {question.answerImage && (
            <img
              src={question.answerImage}
              alt=""
              className="w-full rounded-xl mt-3 max-h-64 object-contain bg-white"
            />
          )}
        </>
      </div>

      {isOwner && question.wrongAnswers?.length > 0 && (
        <div className="rounded-2xl border border-white/10 bg-white/[0.05] p-4 mb-3">
          <div className="text-sm font-semibold text-white/70 mb-2">الإجابات الخاطئة</div>
          <ul className="space-y-1">
            {question.wrongAnswers.map((w, i) => (
              <li key={i} className="text-white/80 text-sm">
                • {w}
              </li>
            ))}
          </ul>
        </div>
      )}

      {date && (
        <p className="text-white/55 text-sm flex items-center gap-1.5 mt-4 mb-5">
          <FaRegCalendarAlt /> تاريخ الإنشاء: {date}
        </p>
      )}

      {isOwner ? (
        <Button block onClick={onEdit} icon={<FaEdit />}>
          تعديل
        </Button>
      ) : (
        <p className="text-white/55 text-sm text-center flex items-center justify-center gap-1.5 mt-4">
          <FaEyeSlash /> وضع المشاهدة فقط
        </p>
      )}
    </Modal>
  );
};

export default QuestionDetail;
